module.exports = __webpack_public_path__ + "static/media/ESG_India.20832f93.svg";